<template>
  <div class="tracktitlecontainer" :class="{ mobile : isMobile }" v-bind:id="track.id" v-on:mouseenter="function() {if (popUp == false){hover = true;}}" v-on:mouseleave="hover = false;"> 
    <img class="bgimage" :src="imageSrc"/>
    <p v-show="userGesture && hover == false">
      <vue-markdown>{{ track.title }}</vue-markdown>
      </p>
      <p v-show="hover == true">
        <vue-markdown>{{ track.artist }}</vue-markdown>
      </p>
  </div>
</template>

<script>
import EventBus from "../Event";
import VueMarkdown from "vue-markdown";

export default {
  name: "trackItem",
  props: ["track", "userGesture", "currentSelection", "popUp", "isActive", "isMobile"],
  components: { VueMarkdown },
  data() {
    return {
      hover: false,
      tileArray: ['tryyy-01.png', 'tryyy-02.png', 'tryyy-04.png', 'tryyy-05.png'],
      imageSrc: null
    };
  },
  created() {
    this.imageSrc = this.tileArray[Math.floor(Math.random()* 3)];
  },
  mounted() { 
    let VueThis = this;
    EventBus.$on("enterPopUp", function(id) {
      if (id != VueThis.track.id) {
      document.getElementById(VueThis.track.id).style.opacity = '0.15';
      document.getElementById(VueThis.track.id).style.zIndex = '0';
      } else {
        document.getElementById(VueThis.track.id).style.zIndex = '10';
      }
    });
    EventBus.$on("exitPopUp", function() {
      document.getElementById(VueThis.track.id).style.opacity = '1';
    });

    document.getElementById(this.track.id).style.height = this.randomNumber(
      "height"
    );
    document.getElementById(this.track.id).style.width = this.randomNumber(
      "width"
    );
  },
  methods: {
    exit() {
      EventBus.$emit("exitPopUp");
    },
    randomNumber(side) {
      let isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      let vwratios = [ 10 , 13 ];
      let vhratios = [ 15 , 20.5 ];
      // window.innerWidth <= 800
      if (isMobile) {
        // hoogte
          if (side == "height") {
          return vhratios[Math.floor(Math.random() * 1.9)] * 4 + "vw";
        } else {
          // breedte
          return vwratios[Math.floor(Math.random() * 1.9)] * 4 + "vw";
        }
      }
      else {
        if (side == "height") {
          return vhratios[Math.floor(Math.random() * 1.9)] + "vh";
        } else {
          return vwratios[Math.floor(Math.random() * 1.9)] + "vw";
        }
      }
    }
  }
};
</script>

<style scoped>
.tracktitlecontainer {
  position:relative;
  background-repeat: no-repeat;
  align-items: center;
  cursor: pointer;
  opacity: 1;
  line-height: 1;
  display: flex;
  flex-direction: row;
  z-index:0;
  color:#3d645d;
}

.tracktitlecontainer p {
  font-size: 2.5vh;
  line-height:1.05;
  font-family: np;
  letter-spacing: -0.1px;
  width: 100%;
  text-align: center;
  align-self: center;
  filter: none;
  word-break:break-word;
  padding: 0 23% 0 20%;
}

#exit {
  top:-10px;;
  position:absolute;
  right:-10px;
}

.tracktitlecontainer img {
  position:absolute;
  width:100%;
  height:100%;
  z-index:-100;
  /* filter: saturate(50%) hue-rotate(-100deg); */
}

.tracktitlecontainer.mobile p {
  font-size: 5.5vw;
}

</style>
